export default __webpack_public_path__ + "static/media/piano_1.3102bf83.png";